module.exports = __webpack_public_path__ + "static/bryan-ruef-hero-small-e10f167c7101bab33e10bbd564e7c64e.jpg";